import api from '@/api/axios'
export default {
	namespaced: true,
	state: {
		locations: [],
	},
	mutations: {
		SET_LOCATIONS(state, payload) {
			state.locations = payload
		},
	},
	actions: {
		async getLocations({ commit }) {
			try {
				commit('setLoading', true, { root: true })
				const locations = await api.get('/admin/locations', {
					params: {
						all: 1,
					},
				})
				commit('SET_LOCATIONS', locations.data.data)
				commit('setLoading', false, { root: true })

			} catch (error) {
				commit('setLoading', false, { root: true })
				return error
			}
		},
	},
}
